import React from "react";
import useFirebase from "../infra-no-ui/firebase/useFirebase.js";
import Firebase from "../infra-no-ui/firebase/Firebase.js";
import useTranslationAuthenticationNoUi from "./useTranslationAuthenticationNoUi.js";

export default function useUpdatePassword() {

  // Send new password callback
  const updatePassword = (newPassword) => {
    setLoading(true);
    setError(null);

    return firebase
      .doPasswordUpdate(newPassword)
      .catch(error => {
        const message = t(Firebase.getErrorTranslation(t, error.code)) + " (code: " + error.code + ")";
        setError(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const {t, loading: tLoading} = useTranslationAuthenticationNoUi();
  const firebase = useFirebase();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  return ({
    updatePassword,
    loading: loading || tLoading,
    error}
  );
}
